import React from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { GlobalViewTaxForm } from './global-viewtaxform';
import { ViewTaxFormPropTypes } from '../../shapes';

const { CountryCode } = Constants;

export const ALTaxViewTaxForm = props => (
  <GlobalViewTaxForm
    {...props}
    countryCode={CountryCode.AL}
    showTaxCert={false}
  />
);

ALTaxViewTaxForm.propTypes = ViewTaxFormPropTypes;
